module.exports = __webpack_public_path__ + "static/img/SONOMA-MDF.4b40b30.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/SONOMA-MDF.png
// module id = 8KUA
// module chunks = 0